<div mode="ios" class="card" (click)="cardClick()" *ngIf="!loading"> 
  <div class="card-content" *ngIf="special; else nothing">
    <div id="topOfCard">
      <div  id="title-container">
        <h2>{{special?.descriptive_tag}}</h2>
      </div>
      <div id="img-container" class="fade-in">
        <img  
        id="background-image"
        [defaultImage]="assetLinksService.cardLoading" 
        [lazyLoad]="special?.picture" 
        [errorImage]="assetLinksService.noImage"
        onerror="this.src='assets/errorimg_ink.png'">
        <!-- <ion-spinner  name="dots"></ion-spinner> -->
      </div>
      <ion-item style="text-align: center;" class="fade-in" *ngIf="!showDescription">
        <ion-label color="secondary">
          <strong>{{special?.restaurant_name}} | {{special?.name}}</strong>
          <p>{{loyaltyCard.expiryDate | daysLeft}}</p>
        </ion-label>
      </ion-item>
      <ion-item style="text-align: center;" class="fade-in" *ngIf="showDescription">
        <ion-label color="secondary">
          <p>{{special.description}}</p>
        </ion-label>
      </ion-item>
    </div>
    <div style="    
    width: 100%;
    height: 2px;
    display: flex;
    margin: 0;
    padding: 0;
    text-align: center;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;">
      <div  style="    
      width: 80%;
      height: 100%;
      border: 1px dashed var(--ion-color-medium);
      margin: 0;
      padding: 0;
      "></div>
    </div>
      <div *ngIf="special" id="stamps-container" >
        <div class="stamp-row" >
          <div class="stamp-container" *ngFor="let int of arrayMaker(loyaltyCard.stickers_count)" size="4">
            <img  class="stamp" [src]='assetLinksService.stamp'> 
          </div>
          <div class="stamp-container"  [id]="'nextStampSlot_'+int" *ngFor="let int of arrayMaker(special.stamps_required - loyaltyCard.stickers_count)" size="4">
            <img  class="stamp" [src]='assetLinksService.stampHolder'>
          </div>
        </div>
      </div>
  </div>
  <ng-template #nothing>
    <div class="card-content">
      <div  id="title-container">
        <h2>Error</h2>
      </div>
      <div id="img-container" class="fade-in">
        <img  
        id="background-image"
        [defaultImage]="assetLinksService.cardLoading" 
        [lazyLoad]="assetLinksService.noImage" 
        [errorImage]="assetLinksService.noImage"
        onerror="this.src='assets/errorimg_ink.png'">
      </div>
        <ion-item  style="text-align: center;--background: white;">
          <ion-label color="secondary">
            <strong>Error fetching loyalty programme</strong>
            <p>
              Please check your internet connection.
              Try closing the app completely (not just minimize) 
              and re-open the app
            </p>
          </ion-label>
        </ion-item>
    </div>
  </ng-template>
</div>


<div
style="height: 50vh; margin: 0.5em;"
mode="ios"
*ngIf="loading">
<ion-skeleton-text animated style="width: 100%;height: 100%;"></ion-skeleton-text>
</div>

